import React from 'react';
import { Link } from "react-router-dom";
import { Password } from "primereact/password";


export default function ChangePasswordField({handleSubmit, handleChange, formValues, errors, Logo, loading}) {
  return (
    <form
    className="card-body cardbody-color p-lg-5 bg-glass"
    onSubmit={handleSubmit}
  >
    <div className="text-center">
      <img
        src={Logo}
        className="img-fluid profile-image-pic img-thumbnail rounded-circle mb-5"
        width="200px"
        alt="profile"
      />
    </div>



    <div className="mb-3">
      {/* <input
        name="text"
        type="password"
        className={
          errors.password
            ? "form-control border border-danger"
            : "form-control"
        }
        id="password"
        placeholder="Password"
        value={formValues.password}
        onChange={(e)=>handleChange(e, 'password')}
        autoComplete="new-username"
        
      /> */}


       <Password
                      name="password"
                      className={
                        errors.password
                          ? "form-password border border-danger"
                          : "form-password"
                      }
                      id="password"
                      placeholder="Password"
                      feedback={false}
                      value={formValues.password}
                      onChange={(e)=>handleChange(e, 'password')}
                      toggleMask
                    />


      {errors.password && (
        <span style={{ color: "red" }}>{errors.password}</span>
      )}
    </div>

    <div className="mb-3">
      {/* <input
        name="re_password"
        type="text"
        className={
          errors.re_password
            ? "form-control border border-danger"
            : "form-control"
        }
        id="re_password"
        placeholder="Re Enter Password"
        value={formValues.re_password}
        onChange={(e)=>handleChange(e, 're_password')}
        autoComplete="new-username"
      /> */}

      
<Password
                      name="re_password"
                      className={
                        errors.password
                          ? "form-password border border-danger"
                          : "form-password"
                      }
                      id="re_password"
                      placeholder="Password"
                      feedback={false}
                      value={formValues.re_password}
                      onChange={(e)=>handleChange(e, 're_password')}
                      toggleMask
                    />
      {errors.re_password && (
        <span style={{ color: "red" }}>{errors.re_password}</span>
      )}
    </div>

  



    <div className="text-center">
      <button
        type="submit"
        className="btn btn-color px-5 mt-1 mb-1 w-100"
        disabled={loading}
      >
        {" "}
        {loading ? "Loading..." : "Change Password"}
      </button>
    </div>

    <Link className="forgot-pass-text" to="/login" >Back to Login</Link>

  </form>
  )
}
